/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFollowButton_seller = {
    readonly serviceId: string | null;
    readonly favoritesByUser?: ReadonlyArray<{
        readonly serviceId: string | null;
    } | null> | null;
    readonly " $refType": "StorefrontFollowButton_seller";
};
export type StorefrontFollowButton_seller$data = StorefrontFollowButton_seller;
export type StorefrontFollowButton_seller$key = {
    readonly " $data"?: StorefrontFollowButton_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFollowButton_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontFollowButton_seller",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId"
            }
          ],
          "concreteType": "Favorite",
          "kind": "LinkedField",
          "name": "favoritesByUser",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();
(node as any).hash = 'f611bf7aab25f961ebcf84d31217e2d9';
export default node;
